import { type UploadedFile } from './UploadedFileCard'

interface Props {
  uploadedFile: UploadedFile
}

export default function FilePreview({ uploadedFile }: Props) {
  const isImage = uploadedFile.content_type.startsWith('image/')

  return (
    <div className="flex-1 flex flex-col bg-slate-950/60 min-h-[260px]">
      <div className="flex-1 flex items-center justify-center p-4 overflow-hidden">
        {isImage ? (
          <img
            src={uploadedFile.url}
            alt={uploadedFile.filename}
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        ) : (
          <div className="flex flex-col items-center gap-3 text-slate-500">
            <svg className="w-14 h-14" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
            <span className="text-sm">{uploadedFile.filename}</span>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between px-4 py-2 border-t border-slate-800 text-slate-500">
        <a
          href={uploadedFile.url}
          target="_blank"
          rel="noreferrer"
          className="hover:text-slate-300 transition-colors"
          title="Open full size"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
          </svg>
        </a>
        <span className="text-xs tabular-nums">100%</span>
        <a
          href={uploadedFile.url}
          target="_blank"
          rel="noreferrer"
          className="hover:text-slate-300 transition-colors"
          title="Open in new tab"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
        </a>
      </div>
    </div>
  )
}
